import { render, staticRenderFns } from "./SSelectTransaction.vue?vue&type=template&id=a8abe4b2"
import script from "./SSelectTransaction.vue?vue&type=script&lang=js"
export * from "./SSelectTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports